import React, { useState, useEffect, memo, useRef } from 'react'
import { useNavigate } from 'react-router-dom';

import classes from './Actions.module.scss';
import { options } from './Options'

const Actions = () => {
    const navigate = useNavigate();
    const modules = JSON.parse(localStorage.getItem('modules'))
    const [isModules, setIsModules] = useState(modules);
    const [fetchedModules, setFetchedModules] = useState([]);
    
    

    useEffect(() => {
        if(modules !==null){
            let arr = []
            for (let item in options) {
                for (let j in modules) {
                    if (options[item].moduleName === modules[j]) {
                        arr = [...arr, options[item]];
                        
                    }
                }
            }

            setFetchedModules(arr)
        }
    }, [])


    return (
        <>
            <div className={classes.Actions}>
                {
                    fetchedModules.map((item) => {
                        return (
                            <div key={item.id} className={classes.ActionsItem} onClick={() => { navigate(item.navigate) }}>
                                <img src={item.src} alt="" width={24} />
                                <p>{item.name}</p>
                            </div>
                        )
                    })
                }
            </div>
        </>
    )
}

export default Actions